export default {
  pageTitle: '相关知识',
  heroDesc: '跨境商务与法律知识库',
  allCategories: '全部',
  companyRegistration: '公司注册',
  taxPlanning: '税务规划',
  legalCompliance: '法律合规',
  crossBorderInvestment: '跨境投资',
  financialManagement: '财务管理',
  other: '其他',
  searchPlaceholder: '搜索文章...',
  featuredArticle: '精选文章',
  readMore: '阅读更多',
  readFullArticle: '阅读全文',
  loadMore: '加载更多文章',
  minutesRead: '分钟阅读',
  categoryCompanyReg: '公司注册',
  categoryTaxPlanning: '税务规划',
  categoryBankAccount: '银行开户',
  categoryLegal: '法律法规',
  categoryCaseStudy: '案例分析',
  categoryIndustryNews: '行业动态',
  categoryVIE: 'VIE架构',
  article1Title: '2024年香港公司注册最新指南',
  article1Excerpt: '详细介绍香港公司注册的流程、所需材料、注意事项以及最新政策变化...',
  article1ReadTime: '8 分钟阅读',
  article2Title: '如何合理利用香港低税率政策',
  article2Excerpt: '深入解析香港税务体系，教您如何在合法合规的前提下优化企业税务结构...',
  article2ReadTime: '10 分钟阅读',
  article3Title: '香港银行开户全攻略：流程与技巧',
  article3Excerpt: '香港主流银行开户要求对比，开户流程详解，常见问题及解决方案...',
  article3ReadTime: '7 分钟阅读',
  article4Title: 'VIE架构详解：搭建与合规要点',
  article4Excerpt: '全面解析VIE架构的概念、搭建流程、法律风险以及合规注意事项...',
  article4ReadTime: '12 分钟阅读',
  article5Title: '跨境电商企业如何通过离岸公司降低成本',
  article5Excerpt: '真实案例分析：某跨境电商企业通过合理的离岸架构，年节省税费数百万...',
  article5ReadTime: '9 分钟阅读',
  article6Title: '2024年ODI境外投资备案政策解读',
  article6Excerpt: '最新ODI政策变化分析，企业如何应对新的监管要求...',
  article6ReadTime: '6 分钟阅读',
}
